module.exports = __webpack_public_path__ + "img/atelier-ms-mai-2025-planning.c52867a.jpg";